import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxWigModule } from 'ngx-wig';
import { HttpClientModule } from '@angular/common/http';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { RegisterComponent } from './components/register/register.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './components/login/login.component';
import { PacijentComponent } from './components/pacijent/pacijent.component';
import { PacijentEditComponent } from './components/pacijent-edit/pacijent-edit.component';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { UserService } from './service/user.service';
import { AuthGuardService } from './guard/auth.service';
import { MyfireService } from './service/myfire.service';
import { NoviPacijentComponent } from './components/novi-pacijent/novi-pacijent.component';
import { FilterPipe } from './filter.pipe';
import { NalazComponent } from './components/nalaz/nalaz.component';
import { NoSanitizePipe } from './no-sanitize.pipe';
import { ObavestenjaComponent } from './components/obavestenja/obavestenja.component';
import { ProfilComponent } from './components/profil/profil.component';
import { DgFilter } from './dgfilter.pipe';
import { BrisanjeDijagnozeComponent } from './components/nalaz/brisanje-dijagnoze/brisanje-dijagnoze.component';
import { ZakazivanjeComponent } from './components/zakazivanje/zakazivanje.component';
import { FooterComponent } from './components/footer/footer.component';
import { BrisanjeComponent } from './components/brisanje/brisanje.component';
import { OrdFilterPipe } from './ord-filter.pipe';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    RegisterComponent,
    DashboardComponent,
    LoginComponent,
    PacijentComponent,
    PacijentEditComponent,
    NotfoundComponent,
    NoviPacijentComponent,
    FilterPipe,
    NalazComponent,
    NoSanitizePipe,
    ObavestenjaComponent,
    ProfilComponent,
    DgFilter,
    BrisanjeDijagnozeComponent,
    ZakazivanjeComponent,
    FooterComponent,
    BrisanjeComponent,
    OrdFilterPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AngularEditorModule,
    NgxWigModule,
    BrowserAnimationsModule,
    ScrollingModule,

    RouterModule.forRoot([
      {
        path: '',
        component: DashboardComponent,

        canActivate: [AuthGuardService]
      },
      { path: 'login', component: LoginComponent },
      { path: 'register', component: RegisterComponent },
      {
        path: 'pacijent/:id',
        component: PacijentComponent,
        canActivate: [AuthGuardService]
      },

      {
        path: 'pacijent/:id/edit',
        component: PacijentEditComponent,

        canActivate: [AuthGuardService]
      },
      {
        path: 'novi-pacijent',
        component: NoviPacijentComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'istorija/:id/:id',
        component: NalazComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'stampa/:id/:id',
        component: NalazComponent,
        canActivate: [AuthGuardService]
      },

      {
        path: 'istorija/:id/:id/brisanje',
        component: BrisanjeDijagnozeComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'obavestenja',
        component: ObavestenjaComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'zakazivanje',
        component: ZakazivanjeComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'users/:id',
        component: ProfilComponent,
        canActivate: [AuthGuardService]
      },
      {
        path: 'brisanje',
        component: BrisanjeComponent,
        canActivate: [AuthGuardService]
      },
      { path: '**', component: NotfoundComponent }
    ])
  ],
  providers: [UserService, AuthGuardService, MyfireService, UserService],
  bootstrap: [AppComponent]
})
export class AppModule {}
